import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { ExportDialogModule } from '@core/components/export-dialog/export-dialog.module';
import { PalantirContentModule } from '@core/components/palantir-content/palantir-content.module';
import { PalantirTextModule } from '@core/components/palantir-text/palantir-text.module';
import { ShowDataInputModule } from '@core/components/show-data-input/show-data-input.module';
import { TagListDialogComponent } from '@core/components/tag-list-dialog/tag-list-dialog.component';
import { TagListDialogModule } from '@core/components/tag-list-dialog/tag-list-dialog.module';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { FuseSidebarModule } from '@fuse/components';
import { StatusMaintenancePipe } from '@fuse/pipes/maintenanceStatus.pipe';
import { PaymentStatusPipe } from '@fuse/pipes/paymentStatus.pipe';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ExportDialogImrModule } from '../../core/components/export-dialog-imr/export-dialog-imr.module';
import { PalantirTagModule } from '../../core/components/palantir-tag/palantir-tag.module';
import { DirectivesModule } from '../../core/directives/directives.module';
import { DelayedIconComponent } from './components/delayed-icon/delayed-icon.component';
import { DialogAlertModule } from './dialogs/dialog-alert/dialog-alert.module';
import { DialogCreateMaintenanceModule } from './dialogs/dialog-create-maintenance/dialog-create-maintenances.module';
import { DialogEditMaintenanceModule } from './dialogs/dialog-edit-maintenance/dialog-maintenances.module';
import { StarsModule } from './dialogs/dialog-edit-maintenance/tabs/logs/stars/stars.module';
import { DialogReallocateMaintenanceModule } from './dialogs/dialog-reallocate-maintenance/dialog-reallocate-maintenance.module';
import { DialogReopenMaintenanceModule } from './dialogs/dialog-reopen-maintenance/dialog-reopen-maintenance.module';
import { FilterMaintenanceModule } from './filter/filter-maintenances.module';
import { MaintenancesComponent } from './maintenances.component';
import { DatatableMaintenancesComponent } from './views/datatable/datatable-maintenances.component';

const routes: Routes = [
  {
    path: 'manutencoes',
    component: MaintenancesComponent,
    canActivate: [AuthenticatedGuard],
    data: { title: 'CORE.SERVICES.NAVIGATION.MAINTENANCES.TITLE' }
  }
];

@NgModule({
  declarations: [
    MaintenancesComponent,
    DatatableMaintenancesComponent,
    DelayedIconComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    TranslateModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatTooltipModule,
    MatSortModule,
    MatPaginatorModule,
    MatTableModule,
    MatButtonModule,
    MatRippleModule,
    MatSortModule,
    MatPaginatorModule,
    MatMenuModule,
    MatDividerModule,
    FuseSharedModule,
    FuseSidebarModule,
    FilterMaintenanceModule,
    DialogEditMaintenanceModule,
    DialogCreateMaintenanceModule,
    DialogReallocateMaintenanceModule,
    DialogReopenMaintenanceModule,
    DialogAlertModule,
    StarsModule,
    ExportDialogModule,
    ExportDialogImrModule,
    DirectivesModule,
    PalantirTagModule,
    PalantirContentModule,
    PalantirTextModule,
    TagListDialogModule,
    ShowDataInputModule
  ],
  exports: [
    MaintenancesComponent,
    CdkTableModule
  ],
  providers: [
    StatusMaintenancePipe,
    PaymentStatusPipe
  ]
})

export class MaintenancesModule {}
